import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { translateReactNode } from '../../../../utils/translateReactNode';

const getYoutubeEmbedUrl = (url: string): string => {
  const shortMatch = url.match(/youtu\.be\/([^?&#/]+)/);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;

  const watchMatch = url.match(/[?&]v=([^?&#]+)/);
  if (watchMatch) return `https://www.youtube.com/embed/${watchMatch[1]}`;

  return url;
};

interface TutorialDialogProps {
  open: boolean;
  tutorialUrl: string;
  onClose: () => void;
}

const TutorialDialog: React.FC<TutorialDialogProps> = ({ open, tutorialUrl, onClose }) => {
  const embedUrl = getYoutubeEmbedUrl(tutorialUrl);
  const tutorialLabel = translateReactNode("Tutorial");
  const closeLabel = translateReactNode("Close") as string;
  const tutorialTitle = tutorialLabel as string;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {tutorialLabel}
        <IconButton aria-label={closeLabel} onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
          <iframe
            title={tutorialTitle}
            src={embedUrl}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TutorialDialog;
